<template>
    <div>
        <h2>落箱提交</h2>
        <van-form @submit="onSubmit">
            <van-field v-model="boxno" label="箱号" placeholder="箱号"/>
            <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit">
                    搜索
                </van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {Form} from 'vant';

    Vue.use(Form);

    export default {
        data() {
            return {
                boxno: '',
            };
        },
        methods: {
            onSubmit(values) {

            },
        },
        mounted() {

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/container-yard/search.vue